// GET COINSELLER
export const GET_COINSELLER = "GET_COINSELLER";
export const GET_COINSELLER_UNIQUEID = "GET_COINSELLER_UNIQUEID";
